import { RoundAllocation } from "@bookings/bookings/api/reviewPackage/types";
import { DEFAULT_PAX } from "@quote/consts";
import { StateCreator } from "zustand";

import { TtaTypeEnum } from "@/types";

import { State, SharedState } from "./types";

const initState: State = {
  roundAllocation: {} as RoundAllocation,
  ttaType: TtaTypeEnum.NONE,
  productCode: "",
  totalGolfers: DEFAULT_PAX,
  quoteRef: "",
};

export const createSharedState: StateCreator<
  SharedState,
  [["zustand/devtools", never]]
> = (set) => ({
  ...initState,

  sharedActions: {
    setQuoteSharedState: (quoteState: Partial<State>) => {
      set(
        (preState) => ({ ...preState, ...quoteState }),
        undefined,
        "shared/setQuoteState",
      );
    },
  },

  sharedUtils: {},
});
